import React, { useEffect, useMemo, useState } from 'react';
import { find, get } from 'lodash-es';
import { useIntl } from 'umi';
import { inject, observer } from 'mobx-react';
import { Icon } from '@/components';
import s from './index.less';
import { Dropdown, MenuProps } from 'antd';
import HoverIcon from '../HoverIcon';
import { Lang } from '@/types/lang';
interface LanguageSelectProps {
  onChange: any;
  originLang: Lang;
  targetLang: Lang;
}
export enum LNAG_TYPE {
  origin = '1',
  target = '2',
}

const LanguageSelect: React.FC<LanguageSelectProps> = inject()(
  observer((props: LanguageSelectProps) => {
    const { onChange, originLang, targetLang } = props;
    const [originKeys, setOriginKeys] = useState<any>([]);
    const [visible, setVisible] = useState<boolean>(false);
    const [targetKeys, setTargetKeys] = useState<any>([]);
    const { formatMessage } = useIntl();
    const $i = (mid: string) => {
      return formatMessage({ id: mid });
    };

    const languageList = [
      {
        key: Lang.auto,
        label: $i('NO_TRANSLATE'),
      },
      {
        key: Lang.zh,
        label: $i('Chinese'),
      },
      {
        key: Lang.en,
        label: 'English',
      },
      {
        key: Lang.ja,
        label: '日本語',
      },
    ];

    const originText = useMemo(() => {
      if (originKeys[1] === LNAG_TYPE.origin) {
        const one = find(languageList, { key: originKeys[0] });
        return one?.label;
      }
      return $i('automaticRecognition');
    }, [originKeys]);

    const targetText = useMemo(() => {
      if (targetKeys[1] === LNAG_TYPE.target) {
        const one = find(languageList, { key: targetKeys[0] });
        return one?.label;
      }
      return $i('NO_TRANSLATE');
    }, [targetKeys]);

    const onClick = (e: any) => {
      if (get(e, 'keyPath.1') === LNAG_TYPE.origin) {
        setOriginKeys(e.keyPath);
        onChange({ originLang: e.keyPath[0], targetLang: targetKeys[0] });
      }
      if (get(e, 'keyPath.1') === LNAG_TYPE.target) {
        setTargetKeys(e.keyPath);
        onChange({ originLang: originKeys[0], targetLang: e.keyPath[0] });
      }
    };

    const items: MenuProps['items'] = [
      {
        key: '1',
        type: 'group',
        label: $i('subtitleRegSourceLang'),
      },
      {
        key: LNAG_TYPE.origin,
        label: <span className={s.auto}>{originText}</span>,
        children: languageList.slice(1).map((item) => {
          if (originKeys[0] === item.key) {
            return {
              ...item,
              icon: (
                <Icon name="icon-check_1" mode="symbol" size={16} className={s.selectIcon}></Icon>
              ),
            };
          }
          return { ...item, icon: <Icon name="" mode="symbol" size={16}></Icon> };
        }),
      },
      {
        key: '3',
        type: 'group',
        label: $i('targetTrasLang'),
      },
      {
        key: LNAG_TYPE.target,
        label: targetText,
        children: languageList.map((item) => {
          if (targetKeys[0] === item.key) {
            return {
              ...item,
              icon: (
                <Icon name="icon-check_1" mode="symbol" size={16} className={s.selectIcon}></Icon>
              ),
            };
          }
          return { ...item, icon: <Icon name="" mode="symbol" size={16}></Icon> };
        }),
      },
    ];
    const handleVisibleChange = (value: boolean) => {
      setVisible(value);
    };

    useEffect(() => {
      setOriginKeys([originLang, LNAG_TYPE.origin]);
      setTargetKeys([targetLang, LNAG_TYPE.target]);
    }, [originLang, targetLang]);
    return (
      <Dropdown
        arrow={false}
        trigger={['click']}
        menu={{
          items,
          // selectedKeys: ['2', 'en'],
          // defaultOpenKeys: ['2', 'en'],
          // openKeys: ['2', 'en'],
          rootClassName: s.languageMenu,
          onClick,
        }}
        overlayClassName={s.dropdown}
        onVisibleChange={handleVisibleChange}
      >
        <HoverIcon
          panelVisible={visible}
          title={formatMessage({ id: 'translate' })}
          name="icon-translateLanguage_11"
        ></HoverIcon>
      </Dropdown>
    );
  })
);

export default LanguageSelect;
